<template>
  <el-container>
    <el-aside style="width:220px;background:#181919;" class="aside">
      <div>
        <div class="tit">医疗机构增补智能评估系统</div>
        <el-menu
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        background-color="transparent"
        text-color="#ccc"
        active-text-color="#1F8FFF"
        :collapse="collapse"
        style="width:100%;"
        :default-active="firstIndex"
        router>
        <label v-for="(menuModel,index) in menus" :key="index">
          <el-menu-item :index="menuModel.path" @click="getName(menuModel)">
            <label v-html="getTitle(menuModel)" style="cursor:pointer"></label>
          </el-menu-item>
        </label>
        </el-menu>
      </div>
    </el-aside>
    <el-container style="height: 100vh;">
      <el-header>
        <div class="header">
           <div class="tt">{{navName}}</div>
           <div>
              <div @click="goHome"><img src="../../assets/img/home.png" />返回首页</div>
              <div @click="loginOut"><img src="../../assets/img/exit.png" />退出</div>
           </div>
        </div>
      </el-header>
      <el-main class="inner">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  export default {
    name: "index",
    data(){
      return {
        collapse:true,
        menus:[],
        firstIndex: '',
        navName: ''
      }
    },
    mounted(){
      this.menus = this.$store.state.userInfo.menus.siteselect
      console.log('menus',this.$store.state.userInfo.menus.siteselect)    
    },
    methods:{
      getName(menuModel){
        this.navName = menuModel.name
      },
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      getTitle:function(mMdel){
        if(mMdel.iconClass != null){
          let html="<div class=\"jicon "+mMdel.iconClass+"\"></div>"
          html+="<div class=\"m_text\">"+mMdel.name+"</div>"
          return html;
        }else{
          return mMdel.name;
        }
      },
      goHome(){
        this.$router.push("/home");
      },
      loginOut(){
        this.$store.commit("setUserInfo",null);
        sessionStorage.removeItem("userInfo");
        this.$router.push("/login");
      }
    },
    watch:{
        menus: {
          handler(newValue) {
            if(newValue != undefined && newValue.length >0){
             let currentModel = newValue[0];
             if(this.$store.state.menuNum){
               this.firstIndex = newValue.filter(item => item.name==this.$store.state.menuNum)[0].path
             }else{
               this.firstIndex = currentModel.path;
             }
               console.log('newValue',this.firstIndex)
             this.navName = currentModel.name;
             this.$router.push(this.firstIndex);
            }
          },
          deep: true
        },
        '$route'(to,from){
          this.firstIndex=to.path
          this.navName = to.name
        }
      }
  }
</script>

<style lang="less" scoped>
.el-menu{border: none;}
.el-menu-item{
  background-color: transparent!important;
  padding: 0!important;
  font-size: 16px;
  margin: 10px 8px;
  border-left: 4px solid transparent;
  label{
    display: flex;
    align-items: center;
  }
}
.el-menu-item, .el-submenu__title{
  height: 40px!important;
  line-height: 40px!important;
}
.el-menu-item.is-active{
  width: 180px;
  height: 40px;
  line-height: 40px;
  background: rgba(31,143,255,0.2)!important;
  border-radius: 2px;
  padding-left: 18px;
  border-left: 4px solid #1F8FFF;
}
.tit{
  height: 60px;
  line-height: 60px;
  background: #1F8FFF;
  color: white;
  font-weight: bold;
  text-align: center;
}
  .el-main {
    height: calc(100vh - 60px);
  }
  /deep/.el-main::-webkit-scrollbar{
    display: none;
  }
  .el-header{padding:0}
  .header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    color: #333333;
    font-weight: bold;
    height: 60px;
    padding: 0;
    background: white;
    border-bottom: 1px solid #0000001a;
    .tt{
      font-size: 18px;
      margin-left: 28px;
    }
    div{
      display: flex;
      align-items: center;
      margin: 0 20px;
      cursor: pointer;
      img{
        width:20px;
        margin-right: 8px;
      }
    }
  }
  .inner{
    padding: 0;
    margin-top: 2px;
  }
</style>
